import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import { useTranslation } from 'react-i18next';

import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import {
  getLoginRedirectUrl,
  getLogoutCallbackUrl,
} from '@/utils/helpers/environment';

const VARIANT_TO_CTA_TYPE = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'ghost',
} as const;

export function BackToLogin({
  variant = 'primary',
  logoutFirst = false,
}: Readonly<{
  variant?: 'primary' | 'secondary' | 'tertiary';
  logoutFirst?: boolean;
}>) {
  const { t } = useTranslation('common');
  const locale = useTransactionLocale();

  const buttonText = t('button.backToLogin');

  const handleBackToLogin = () => {
    window.location.href = logoutFirst
      ? getLogoutCallbackUrl(locale)
      : getLoginRedirectUrl(locale);
  };

  return (
    <CtaContainer stack>
      <Cta type={VARIANT_TO_CTA_TYPE[variant]} onClick={handleBackToLogin}>
        {buttonText}
      </Cta>
    </CtaContainer>
  );
}
